import { successAction, types } from "@authzsvc/api-lib";

export default (state = { allowed: [], granted: [] }, action) => {
  switch (action.type) {
    case successAction(types.GET_ALLOWED_TOKEN_EXCHANGE_PERMISSIONS):
      return { ...state, allowed: [...action.payload.data] };
    case successAction(types.GET_GRANTED_TOKEN_EXCHANGE_PERMISSIONS):
      return { ...state, granted: [...action.payload.data] };
    default:
      return state;
  }
};
